import { render, staticRenderFns } from "./OtherInvoices.vue?vue&type=template&id=b1b2b5a0&"
import script from "./OtherInvoices.vue?vue&type=script&lang=js&"
export * from "./OtherInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports